module.exports = __webpack_public_path__ + "img/christian.8c64339c.jpg";